// @ts-ignore
export const Liferay = window.Liferay || {
    ThemeDisplay: {
        getCanonicalURL: () => window.location.href,
        getCompanyGroupId: () => 0,
        getLanguageId: () => 'de_DE',
        getLayoutRelativeURL: () => '',
        getPathThemeImages: () => null,
        getPortalURL: () => window.location.origin,
        getScopeGroupId: () => 0,
        getSiteGroupId: () => 0,
        getUserId: () => '0',
    },
    Util: {
        isTablet: () => false,
        navigate: (path: string) => window.location.assign(path),
    },
    detach: (type: any, callback: any) =>
        window.removeEventListener(type, callback),
    on: (type: any, callback: any) => window.addEventListener(type, callback),
    once: (type: any, callback: any) =>
        window.addEventListener(type, function handler() {
            this.removeEventListener(type, handler);

            callback();
        }),
    publish: (name: any) => ({
        fire: (data: any) =>
            window.dispatchEvent(
                new CustomEvent(name, {
                    bubbles: true,
                    composed: true,
                    ...data,
                })
            ),
    }),
};